import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { ThumbActions, ThumbStoreProps } from "./Thumb.types";

const initialState: ThumbStoreProps = {
  isUploadModalOpen: false,
  isLoading: false,
};

export const useThumbStore = create<ThumbActions & ThumbStoreProps>()(
  devtools((set, get) => ({
    ...initialState,
    openUploadModal: () => set({ isUploadModalOpen: true }),
    closeUploadModal: () => set({ isUploadModalOpen: false }),
    setLoading: (isLoading: boolean) => set({ isLoading }),
  }))
);
